module.exports = __webpack_public_path__ + "static/media/mojo4.fa2bc03e.webp";